import React from "react";
import { Row, Col, Menu, Dropdown, Icon } from "antd";
import middleware from "../../middleware";
class Main extends React.Component {
  constructor(props) {
    super(props);
    this.instanceIsMounted = false;
    this.state = {
      value: props.value || ""
    };
  }
  componentDidMount() {
    this.instanceIsMounted = true;
  }
  componentWillReceiveProps(nextProps) {
    if (this.props.value !== nextProps.value && nextProps.value) {
      this.setState({ value: nextProps.value });
    }
  }
  componentWillUnmount() {
    this.instanceIsMounted = false;
  }
  render() {
    const {
      dropMenu = [],
      defaultMenu,
      adaptWidth = false,
      className = "",
      outStyle
    } = this.props;
    const { value } = this.state;
    let showName = "";
    const menuItem = [];
    dropMenu.forEach(item => {
      const width = $(".wea-drop-menu").width();
      const style = adaptWidth && width ? { width: width - 7 } : {};
      menuItem.push(
        <Menu.Item key={item.companyid} title={item.name} style={style}>
          {item.name}
        </Menu.Item>
      );
      menuItem.push(<Menu.Divider />);
      if (item.companyid === value) {
        showName = item.name;
      }
    });
    const typeMenu = (
      <Menu
        className="wea-browser-drop-menu max-height-large"
        onSelect={this.menuSelect}
        selectedKeys={[value]}
      >
        {menuItem}
      </Menu>
    );
    return (
      <div
        className={`wea-drop-menu ${className}`}
        style={{ width: "100%", ...outStyle }}
      >
        <Row>
          <Col span={24}>
            <Dropdown overlay={typeMenu} trigger={["click"]}>
              <a className="ant-dropdown-link text-elli pr25">
                <i className={"icon-toolbar-Organization-list"} />
                <span title={showName || defaultMenu || ""}>
                  {showName || defaultMenu || null}{" "}
                </span>
                <Icon type="down" className="icon-down" />
              </a>
            </Dropdown>
          </Col>
        </Row>
      </div>
    );
  }
  menuSelect = e => {
    if (typeof this.props.onSelect === "function") {
      this.props.onSelect(e);
      this.setState({ value: e.key });
    }
  };
}

const Com = middleware(Main, "WeaDropMenu");
export default Com;



// WEBPACK FOOTER //
// ./ecology9/wea-drop-menu/index.js